import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'
import { post, get } from "../../helpers/api_helper";

// actions
import { createCompany, companySuccess, companyError, updateCompany } from "../../store/actions";
import { getProfile } from '../../store/auth/profile/actions';
import Loader from "../../components/Loader";
import LeadSingle from './LeadSingle';

const Leads = props => {
  const { user } = props;
  const [isAddForm, setIsAddForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState("day");
  const [leadId, setLeadId] = useState(null);
  // filter selected values
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedClient, setSelectedClient] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [selectedModer, setSelectedModer] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  // console.log('props on Leads', props);
  const [filterObj, setFilterObj] = useState(null);

  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);

  const getData = () => {
    console.log('calling get slots');
  }

  const handleChangeInput = (list, to) => {
    switch (to) {
      case 'status':
        setSelectedStatus(list);
        break;
      case 'client':
        setSelectedClient(list);
        break;
      case 'project':
        setSelectedProject(list);
        break;
      case 'moder':
        setSelectedModer(list);
        break;
      case 'dealer':
        setSelectedDealer(list);
        break;
    }

  }

  const resetFilter = () => {
    setSelectedStatus([]);
    setSelectedClient([]);
    setSelectedProject([]);
    setSelectedModer([]);
    setSelectedDealer([]);
    setFilterObj(null);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Slot Management" />
        <Card>
          <CardBody>
            <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 10 }}>
              <div>
                <CardTitle className="h4">{props.role}</CardTitle>
              </div>
              <div className="text-center" style={{ marginLeft: 'auto' }}>
                {/* {currentTab != "single" ?
                    <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }} onClick={() => setIsAddForm(true)}>
                      Add
                    </Button>
                    :
                    <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }} onClick={() => props?.history?.goBack()}>
                      Back
                    </Button>
                  } */}
              </div>
            </div>
            {currentTab == "day" &&
              <LeadSingle
                user={user}
                leadId={leadId}
                setIsAddForm={setIsAddForm}
                loading={loading}
                setLoading={setLoading}
              />
            }
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  )
}

Leads.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  const { company } = state.Company;
  return { user, company }
}

export default withRouter(
  connect(mapStatetoProps, { createCompany, companySuccess, companyError, getProfile, updateCompany })(Leads)
)
